export default __webpack_public_path__ + "static/staff-photo-1-9f5a57fb763612ecac793c3f022c0c72.jpg";